import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_3 = ["required", "readonly", "min", "max"]
const _hoisted_4 = {
  key: 0,
  class: "form-text text-muted"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "error" }
const _hoisted_9 = {
  key: 1,
  class: "form-text text-muted"
}

import { ref, computed, watch, onMounted, toRef } from 'vue'
    import { formatStringForDateInput } from "@common/Common"

    import type { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels"
    import type { ValidationError } from "@common/types"

    /* props */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DateInputSingleValue',
  props: {
    propF: {},
    propErrors: {}
  },
  setup(__props: any) {

    const props = __props

    /* shortcuts */

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    /* derived */

    const error = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )

    const minDate = computed(() => formatStringForDateInput(f.value.MinDate))
    const maxDate = computed(() => formatStringForDateInput(f.value.MaxDate))

    /* local state */

    const value = ref<string | null>(null)

    /* sync back to domain */

    watch(value, (newValue) => {
         f.value.Value = newValue
    })

    /* init */

    onMounted(() =>
    {
        value.value = formatStringForDateInput(f.value.Value)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      (f.value.IsRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(f.value.Name), 1 /* TEXT */)
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "date",
      class: "form-control",
      placeholder: "Date...",
      title: "Please enter date",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      required: f.value.IsRequired === true,
      readonly: f.value.IsReadonly === true,
      min: minDate.value,
      max: maxDate.value
    }, null, 8 /* PROPS */, _hoisted_3), [
      [_vModelText, value.value]
    ]),
    (minDate.value || maxDate.value)
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
          (minDate.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Earliest: " + _toDisplayString(minDate.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (minDate.value && maxDate.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · "))
            : _createCommentVNode("v-if", true),
          (maxDate.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Latest: " + _toDisplayString(maxDate.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_8, _toDisplayString(error.value), 1 /* TEXT */),
    (f.value.Description)
      ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(f.value.Description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})